// Prüfung der Eingaben auf der Anmeldeseite, bevor etwas zum Server geht. Reine Logik ohne DOM,
// damit sie geprüft werden kann; die Karten in seite.ts zeigen nur, was hier herauskommt.
//
// Die Regeln sind dieselben wie im Server (server/src/auth/regeln.ts) und die Meldungen wörtlich
// dieselben: Ein Kind soll nicht zwei verschiedene Sätze für denselben Fehler lesen. Die Prüfung
// hier ist Höflichkeit, keine Sicherheit – entschieden wird immer auf dem Server.

/** Name: drei bis sechzehn Buchstaben oder Ziffern (wie NAME_REGEX im Server). */
const NAME_REGEX = /^[A-Za-z0-9]{3,16}$/;
/** Kürzestes erlaubtes Passwort. */
const MIN_PASSWORT_LAENGE = 6;

const MELDUNG_NAME = 'Der Name braucht drei bis sechzehn Buchstaben oder Ziffern, sonst nichts.';
const MELDUNG_PASSWORT = 'Das Passwort braucht mindestens sechs Zeichen.';

export interface AnmeldeEingabe {
  name: string;
  passwort: string;
}

export interface KontoEingabe {
  name: string;
  passwort: string;
  einladungscode: string;
}

export interface PasswortEingabe {
  name: string;
  code: string;
  passwort: string;
}

/** Ergebnis einer Prüfung: die geputzten Werte zum Absenden oder eine fertige deutsche Meldung. */
export type Pruefung<T> = { ok: true; werte: T } | { ok: false; fehler: string };

function fehler(text: string): { ok: false; fehler: string } {
  return { ok: false, fehler: text };
}

/**
 * Anmelden: Beide Felder müssen gefüllt sein, mehr nicht. Die Namensregel wird hier absichtlich
 * nicht geprüft – ein Konto von früher könnte anders heißen, und ob Name und Passwort passen,
 * weiß nur der Server.
 */
export function pruefeAnmeldung(eingabe: AnmeldeEingabe): Pruefung<AnmeldeEingabe> {
  const name = eingabe.name.trim();
  if (name === '' || eingabe.passwort === '') return fehler('Bitte Namen und Passwort eintragen.');
  return { ok: true, werte: { name, passwort: eingabe.passwort } };
}

/** Neues Konto: Name und Passwort nach Regel, dazu ein Einladungscode. */
export function pruefeNeuesKonto(eingabe: KontoEingabe): Pruefung<KontoEingabe> {
  const name = eingabe.name.trim();
  if (!NAME_REGEX.test(name)) return fehler(MELDUNG_NAME);
  if (eingabe.passwort.length < MIN_PASSWORT_LAENGE) return fehler(MELDUNG_PASSWORT);
  const einladungscode = eingabe.einladungscode.trim();
  if (einladungscode === '') {
    return fehler('Ohne Einladungscode geht es nicht. Er kommt von dem, der das Spiel betreut.');
  }
  return { ok: true, werte: { name, passwort: eingabe.passwort, einladungscode } };
}

/** Passwort vergessen: Name, Rücksetzcode und das neue Passwort nach Regel. */
export function pruefeNeuesPasswort(eingabe: PasswortEingabe): Pruefung<PasswortEingabe> {
  const name = eingabe.name.trim();
  if (name === '') return fehler('Bitte deinen Namen eintragen.');
  const code = eingabe.code.trim();
  if (code === '') return fehler('Bitte den Rücksetzcode eintragen.');
  if (eingabe.passwort.length < MIN_PASSWORT_LAENGE) return fehler(MELDUNG_PASSWORT);
  return { ok: true, werte: { name, code, passwort: eingabe.passwort } };
}
